function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import LongFooter from "segments/desktop/core-components/long-footer/long-footer";
import SlimFooter from "segments/desktop/core-components/slim-footer/slim-footer.js";
import { SLIM, LONG } from "./footer-consts";
import DefaultProps from "./default-props";
import { StyledBaseFooterComponent } from "./base-footer-component.scss";
const BaseFooterComponent = (props)=>{
    const Footer = {
        [LONG]: LongFooter,
        [SLIM]: SlimFooter
    }[props.footer_type] || SlimFooter;
    return /*#__PURE__*/ _jsx(StyledBaseFooterComponent, {
        className: "base-footer-component",
        children: /*#__PURE__*/ _jsx(Footer, _object_spread({}, props))
    });
};
BaseFooterComponent.defaultProps = DefaultProps;
export default BaseFooterComponent;
